"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setClientId = exports.setAxiosToken = exports.isAxiosTokenSet = exports.initHttpClient = exports.getAxiosProvider = exports.default = exports.apiClient = void 0;
var _reduxSaga = require("redux-saga");
var _axios = _interopRequireWildcard(require("axios"));
var _middlewares = require("../resources/network/middlewares");
var _actions = require("../resources/session/actions");
var _actions2 = require("../resources/network/actions");
var _callbacks = _interopRequireDefault(require("../callbacks"));
var _errorHandler = _interopRequireDefault(require("../utils/errorHandler"));
var _logger = _interopRequireDefault(require("../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('service:apiClient');
var axiosProvider = _axios.default;
var allowedMethod = ['get', 'post', 'put', 'patch', 'head', 'delete'];
class EventEmitter {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }
  off(event, listenerToRemove) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
  }
  emit(event, payload) {
    if (!this.events[event]) return;
    this.events[event].forEach(listener => listener(payload));
  }
}
var eventEmitter = new EventEmitter();

/*
 * @param {Object} options
 * @param {String} options.method
 * @param {String} options.url
 * @param {Object} options.body
 * @param {Boolean} options.ignoreError - dont send error to client
 */
var apiClient = _ref => {
  var {
    method,
    url,
    body,
    ignoreError = false
  } = _ref;
  if (!url) throw new Error('axios: no url defined');
  if (typeof url !== 'string') throw new Error('axios: url defined is not a string');
  if (!method) throw new Error('axios: no method defined');
  if (typeof method !== 'string') throw new Error('axios: method defined is not a string');
  if (!allowedMethod.includes(method.toLowerCase())) {
    throw new Error("axios: method ".concat(method.toLowerCase(), " is not allowed (").concat(allowedMethod, ")"));
  }
  var source = _axios.CancelToken.source();
  var request = axiosProvider[method.toLowerCase()](url, _objectSpread({}, body), {
    cancelToken: source.token,
    ignoreError
  });
  request[_reduxSaga.CANCEL] = () => source.cancel();
  return request;
};
exports.apiClient = apiClient;
var getAxiosProvider = () => axiosProvider;
exports.getAxiosProvider = getAxiosProvider;
var initHttpClient = exports.initHttpClient = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (config) {
    var logErrorToSentry = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (error) {
        var _error$config, _error$config2, _error$response, _JSON$stringify, _error$response2, _error$response3, _config$sentry, _error$config3, _error$response5, _error$response6, _config$session;
        logger.error("[%s]".concat(error.response ? 'Response' : 'Request', ":error %s %o"), (_error$config = error.config) === null || _error$config === void 0 || (_error$config = _error$config.method) === null || _error$config === void 0 ? void 0 : _error$config.toUpperCase(), (_error$config2 = error.config) === null || _error$config2 === void 0 ? void 0 : _error$config2.url, (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status, (_JSON$stringify = JSON.stringify(((_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.message) || '')) === null || _JSON$stringify === void 0 ? void 0 : _JSON$stringify.substr(0, 200), error.status, error.statusText);
        if (!error.config.ignoreError) {
          eventEmitter.emit('apiError', error);
        }

        // trace timeouts on web but not on mobile to avoid potential performances issues
        if ((config.debug || config.sentry.networkError) && ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) > 404 || (_config$sentry = config.sentry) !== null && _config$sentry !== void 0 && _config$sentry.timeout && (0, _middlewares.isNetworkError)(error)) {
          _errorHandler.default.captureException(error, 'axios:interceptor');
        }
        if ((0, _middlewares.isNetworkError)(error)) {
          var _error$response4;
          if ((error === null || error === void 0 || (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status) === 408 || (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED') {
            // Request Timeout
            _callbacks.default.get('dispatch')((0, _actions2.updateConnectedStatus)(false));
          }
          // Otherwise we are not really disconnected from the network.
          // Let the app manage server errors used for normal workflow
          // like 401, 403, 422.
        }

        if ((_error$config3 = error.config) !== null && _error$config3 !== void 0 && _error$config3.metadata && (_error$response5 = error.response) !== null && _error$response5 !== void 0 && _error$response5.status) {
          var {
            httpMetric
          } = error.config.metadata;
          if (httpMetric) {
            httpMetric.setHttpResponseCode(error.response.status);
            yield httpMetric.stop();
          }
        }
        if ((error === null || error === void 0 || (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status) === 401 && !((_config$session = config.session) !== null && _config$session !== void 0 && _config$session.isGuest) && !error.config.url.includes('auth/login') && !error.config.url.includes('auth/check')) {
          _callbacks.default.get('dispatch')((0, _actions.logout)());
          _callbacks.default.get('dispatch')((0, _actions.purgeSession)());
        }
        return Promise.reject(error);
      });
      return function logErrorToSentry(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    axiosProvider = _axios.default.create({
      baseURL: config.apiServerUrl,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      timeout: 60000
    });
    axiosProvider.interceptors.response.use( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (response) {
        var _response$config, _response$config2;
        if (response.config && response.config.metadata && response.status) {
          var {
            httpMetric
          } = response.config.metadata;
          if (httpMetric) {
            httpMetric.setHttpResponseCode(response.status);
            yield httpMetric.stop();
          }
        }
        logger.debug('[%s]Response:ok %s %s', (_response$config = response.config) === null || _response$config === void 0 || (_response$config = _response$config.method) === null || _response$config === void 0 ? void 0 : _response$config.toUpperCase(), (_response$config2 = response.config) === null || _response$config2 === void 0 ? void 0 : _response$config2.url, response.status);
        return response;
      });
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }(), logErrorToSentry);
    axiosProvider.interceptors.request.use( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(function* (requestConfig) {
        var firebasePerf = _callbacks.default.get('firebasePerf')();
        logger.debug('[%s]Request %s %o', requestConfig.method.toUpperCase(), requestConfig.url, requestConfig.body);
        if (firebasePerf) {
          var httpMetric = firebasePerf.newHttpMetric(requestConfig.url, requestConfig.method.toUpperCase());
          if (httpMetric) {
            requestConfig.metadata = {
              httpMetric
            };
            yield httpMetric.start();
          }
        }
        return requestConfig;
      });
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }(), logErrorToSentry);
  });
  return function initHttpClient(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var isAxiosTokenSet = () => !!axiosProvider.defaults.headers.common.Authorization;
exports.isAxiosTokenSet = isAxiosTokenSet;
var setAxiosToken = token => {
  axiosProvider.defaults.headers.common.Authorization = token;
};
exports.setAxiosToken = setAxiosToken;
var setClientId = _client => {
  axiosProvider.defaults.headers.common.clientid = _client;
};
exports.setClientId = setClientId;
var _default = exports.default = {
  apiClient,
  getAxiosProvider,
  initHttpClient,
  setClientId,
  setAxiosToken,
  eventEmitter
};